import { MDBCol, MDBRow, } from "mdb-react-ui-kit";
import { useCurrentUserRoles } from "../../../hooks/useCurrentUserRoles";
import useResumeProperties from "../../../hooks/useResumeProperties";

export default function Footer() {

    const { isAlcyone, isLusis, userData } = useResumeProperties();
    const { currentUser, isClientRole, isManagerRole, isCandidateRole } = useCurrentUserRoles();

    return (
        <>
            <footer className={ isLusis ? "cv-footer-lusis" : "cv-footer" } style={ { fontSize: "10px" } }>
                <MDBRow className="mx-5 pt-4">
                    <MDBCol style={ { marginTop: "33px" } }>
                        <div className="manager-preview text-start text-white">
                            {
                                isManagerRole
                                    ? (
                                        <>
                                            <p className="mb-0">
                                                { currentUser?.prenom } { currentUser?.nom.toUpperCase() }
                                            </p>
                                            <p className="mb-0">{ currentUser?.managerDetails?.poste }</p>
                                            <p className="mb-0">{ currentUser?.phone }</p>
                                            <p className="mb-0">{ currentUser?.email }</p>
                                        </>
                                    )
                                    : isCandidateRole
                                        ? (
                                            <>
                                                <p className="mb-0">
                                                    { userData?.manager?.prenom } { userData?.manager?.nom.toUpperCase() }
                                                </p>
                                                <p className="mb-0">{ userData?.manager?.managerDetails?.poste }</p>
                                                <p className="mb-0">{ userData?.manager?.phone }</p>
                                                <p className="mb-0">{ userData?.manager?.email }</p>
                                            </>
                                        )
                                        : isClientRole
                                            ? (
                                                <>
                                                    <p>+ 352 27 86 17 46</p>
                                                    <p>contact@alcyone-consulting.lu</p>
                                                </>
                                            )
                                            : null
                            }
                        </div>
                    </MDBCol>
                    { isAlcyone &&
                        <MDBCol>
                            <div className="d-flex gap-3 justify-content-end align-items-center">
                                <div>
                                    <img
                                        src="/logo-footer.png"
                                        height="60"
                                        alt="Alcyone-logo"
                                        className="logo-footer"
                                        style={ { marginTop: "20px" } }
                                    />
                                </div>
                            </div>
                        </MDBCol>
                    }
                </MDBRow>
            </footer>
        </>
    );
}
